import {
  UPDATE_SEARCH_KEYWORD,
  SUBMIT_SEARCH_BY_ENTER,
  SET_SEARCH_CONTEXT,
} from "../actions";

export const updateSearchKeyword = (keyword) => {
  return {
    type: UPDATE_SEARCH_KEYWORD,
    payload: keyword, // Dữ liệu từ input sẽ nằm ở đây
  };
};

// Action mới không cần payload, nó chỉ là một tín hiệu
export const submitSearchByEnter = () => ({
  type: SUBMIT_SEARCH_BY_ENTER,
});

// Action để set search context theo trang hiện tại
export const setSearchContext = (context) => ({
  type: SET_SEARCH_CONTEXT,
  payload: context, // 'dashboard' | 'product' | 'stock' | 'customer' | 'order' | ...
});
